import React, { useEffect } from 'react';
import { OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap';
import JSZip from 'jszip';
import { saveAs } from 'save-as';
import { NavLink } from 'react-router-dom';
import { downloadDoc } from '../../api/api';
import {
    resolveDownloadFileName,
    showErrorToast,
} from '../../../components/commonfunction';
import { Notes } from './Notes';
import AllowMultipleEditModal from '../../../components/datagrid/AllowMultipleEditModal';
import { outboxPage, showLoader } from '../../_redux/actions/outboxActions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { DocumentIdToPrint } from '../../../../utils/printPdf/printPdf';

export function MultipleSelection(props) {
    const [printDoc, setPrintDoc] = React.useState([]);
    const [openNote, setOpenNote] = React.useState(false);
    const [editURL, setEditURL] = React.useState(false);
    const [multipleID, setMultipleID] = React.useState('');
    const [restrictAllowEdit, setRestrictAllowEdit] = React.useState(false);
    const entering = (e) => {
        e.children[0].style.borderTopColor = 'rgb(0, 35, 58)';
        e.children[1].style.backgroundColor = 'rgb(0, 35, 58)';
    };
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        let urlConst;
        const docId = props.docIds;
        let editId = '';
        let multiple_id = '';
        // eslint-disable-next-line array-callback-return

        docId.map((id) => {
            editId += `/${window.btoa(String(id))}`;
            if (multiple_id === '') {
                multiple_id += `${window.btoa(String(id))}`;
            } else {
                multiple_id += `/${window.btoa(String(id))}`;
            }
        });

        if (props.docIds.length === 1) {
            urlConst = `/documents/edit${editId}`;
        } else {
            //urlConst = `/documents/editmultiple${editId}`;
            urlConst = `/outbox/editmultiple?editmultiple=${multiple_id}`;
        }
        if (
            String(location.pathname).includes('detail') === true &&
            String(location.pathname).includes('editmultiple') !== true
        ) {
            multiple_id += `/${location.state.selectedDocID}`;
            urlConst = `/outbox/detail/editmultiple?editmultiple=${multiple_id}`;
        }

        setMultipleID(multiple_id);
        setEditURL(urlConst);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props, location]);

    const downloadMultipleDoc = async () => {
        const docid = props.docIds;
        const rowData = props.rowData || [];

        let status = '';
        // const files = false;
        let status_200 = 0;
        const zip = new JSZip();
        const img = zip.folder('PDF');
        // images is the folder which will be zip
        let count = 0;
        let blob = '';
        const usedFileNames = new Set();
        const resolveUniqueFileName = (fileName, fallbackSuffix) => {
            if (!fileName) return `${fallbackSuffix}.pdf`;
            let uniqueName = fileName;
            if (usedFileNames.has(uniqueName)) {
                uniqueName = `${fileName.replace(
                    /\.pdf$/i,
                    ''
                )}-${fallbackSuffix}.pdf`;
            }
            usedFileNames.add(uniqueName);
            return uniqueName;
        };
        await docid.forEach((doc_id, index) => {
            const rowDetails = rowData.find(
                (row) =>
                    String(row.doc_id) === String(doc_id) ||
                    String(row.id) === String(doc_id)
            );
            downloadDoc(doc_id)
                .then((response) => {
                    status = response.status;
                    return response.blob();
                })
                .then(async (data) => {
                    count += 1;
                    if (status === 200) {
                        blob = data;
                        status_200 += 1;
                        const resolvedFileName = await resolveDownloadFileName({
                            docId: doc_id,
                            rowDetails,
                            fallbackName: `${doc_id}.pdf`,
                        });
                        const uniqueFileName = resolveUniqueFileName(
                            resolvedFileName,
                            doc_id
                        );
                        img.file(uniqueFileName, data, { base64: true });
                    }
                    if (docid.length === count && status_200 > 1) {
                        zip.generateAsync({ type: 'blob' }).then(function (
                            content
                        ) {
                            saveAs(content, 'Document.zip');
                        });
                    }
                    if (docid.length === count && status_200 === 1) {
                        const resolvedFileName = await resolveDownloadFileName({
                            docId: doc_id,
                            rowDetails,
                            fallbackName: 'Document.pdf',
                        });
                        saveAs(blob, resolvedFileName);
                    }
                    if (docid.length === count && status_200 === 0) {
                        showErrorToast('No PDF to download');
                    }
                });
        });
    };
    const print = (docId) => {
        // docId = [863];
        if (docId.length === 0) {
            return false;
        }
        dispatch(showLoader(true));
        setPrintDoc(docId);
    };

    const openNoteModal = () => {
        setOpenNote(true);
    };
    const handleReset = () => {
        setOpenNote(false);
    };
    const handleCloseOperation = () => {
        setRestrictAllowEdit(false);
    };
    const openEditError = () => {
        setRestrictAllowEdit(true);
    };

    const handleMultiplePage = () => {
        dispatch(
            outboxPage({
                multiple_edit_page: true,
            })
        );
    };

    // print
    useEffect(() => {
        if (printDoc.length > 0) {
            DocumentIdToPrint(printDoc)
                .then(() => {
                    dispatch(showLoader(false));
                })
                .catch((err) => {
                    console.log('catch', err);
                    dispatch(showLoader(false));
                });
        }
    }, [printDoc]);

    return (
        <>
            {' '}
            <div className='right-aside pdf_section_multiselect mt-3'>
                <div className='bottom-function d-flex align-items-stretch justify-content-between'>
                    <div className='d-flex align-items-center ml-6 selected_count'>
                        {props.documentCount}{' '}
                    </div>
                    <div className='bottom-icons d-flex align-items-center'>
                        {props.allActions !== undefined &&
                        props.allActions.follow_up_notes !== undefined ? (
                            <OverlayTrigger
                                placement='top'
                                onEntering={entering}
                                overlay={
                                    <Tooltip
                                        id='tooltip'
                                        style={{
                                            backgroundColor: 'rgb(0, 35, 58)',
                                            color: 'white',
                                            marginBottom: '15px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundColor:
                                                    'rgb(0, 35, 58)',
                                                color: 'white',
                                            }}
                                        >
                                            Notes
                                        </div>
                                    </Tooltip>
                                }
                            >
                                <div
                                    className='icon_fun outer-col fst-icon'
                                    onClick={() => {
                                        openNoteModal();
                                    }}
                                >
                                    <i className='fa-solid fa-sticky-note' />
                                </div>
                            </OverlayTrigger>
                        ) : null}
                        {window.location.pathname.includes('search') !== true &&
                            window.location.pathname.includes('report') !==
                                true && (
                                <OverlayTrigger
                                    placement='top'
                                    onEntering={entering}
                                    overlay={
                                        <Tooltip
                                            id='tooltip'
                                            style={{
                                                backgroundColor:
                                                    'rgb(0, 35, 58)',
                                                color: 'white',
                                                marginBottom: '15px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor:
                                                        'rgb(0, 35, 58)',
                                                    color: 'white',
                                                }}
                                            >
                                                Merge / Split Documents
                                            </div>
                                        </Tooltip>
                                    }
                                >
                                    {props.docIds.length > 4 ? (
                                        <div
                                            onClick={openEditError}
                                            className='icon_fun outer-col'
                                        >
                                            <i className='fas fa-file-medical-alt' />
                                        </div>
                                    ) : (
                                        <NavLink
                                            to={{
                                                pathname:
                                                    props.propsCalingFrom ===
                                                    'report'
                                                        ? '/reports/editmultiple'
                                                        : String(
                                                              location.pathname
                                                          ).includes(
                                                              'detail'
                                                          ) === true
                                                        ? '/outbox/detail/editmultiple'
                                                        : '/outbox/editmultiple',
                                                selectedDocIds: props.docIds,
                                                editIds: editURL,
                                                search:
                                                    '?editmultiple=' +
                                                    multipleID,
                                                state: {
                                                    selectedDocID:
                                                        location.state !==
                                                            undefined &&
                                                        location.state !==
                                                            null &&
                                                        location.state
                                                            .selectedDocID !==
                                                            undefined &&
                                                        location.state
                                                            .selectedDocID !==
                                                            null
                                                            ? location.state
                                                                  .selectedDocID
                                                            : undefined,
                                                    processId:
                                                        location.state !==
                                                            undefined &&
                                                        location.state !==
                                                            null &&
                                                        location.state
                                                            .processId !==
                                                            undefined &&
                                                        location.state
                                                            .processId !== null
                                                            ? location.state
                                                                  .processId
                                                            : undefined,
                                                    statusId:
                                                        location.state !==
                                                            undefined &&
                                                        location.state !==
                                                            null &&
                                                        location.state
                                                            .statusId !==
                                                            undefined &&
                                                        location.state
                                                            .statusId !== null
                                                            ? location.state
                                                                  .statusId
                                                            : undefined,
                                                },
                                            }}
                                            onClick={() => {
                                                dispatch(
                                                    outboxPage({
                                                        multiple_edit_page: true,
                                                    })
                                                );
                                                if (
                                                    String(
                                                        location.pathname
                                                    ).includes('detail') ===
                                                    true
                                                ) {
                                                    dispatch(
                                                        outboxPage({
                                                            related_doc_detail: false,
                                                        })
                                                    );
                                                }
                                            }}
                                        >
                                            <div className='icon_fun outer-col'>
                                                <i className='fas fa-file-medical-alt' />
                                            </div>
                                        </NavLink>
                                    )}
                                </OverlayTrigger>
                            )}
                        <Dropdown className='bulk-print-opt icon_fun'>
                            <OverlayTrigger
                                placement='top'
                                onEntering={entering}
                                overlay={
                                    <Tooltip
                                        id='tooltip'
                                        style={{
                                            backgroundColor: 'rgb(0, 35, 58)',
                                            color: 'white',
                                            marginBottom: '20px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundColor:
                                                    'rgb(0, 35, 58)',
                                                color: 'white',
                                            }}
                                        >
                                            Settings
                                        </div>
                                    </Tooltip>
                                }
                            >
                                <Dropdown.Toggle
                                    variant='success'
                                    id='dropdown-basic'
                                >
                                    <i
                                        className='fa fa-ellipsis-v'
                                        aria-hidden='true'
                                    />
                                </Dropdown.Toggle>
                            </OverlayTrigger>

                            <Dropdown.Menu>
                                <Dropdown.Item
                                    title='Print'
                                    className='print-dropdown'
                                >
                                    <span
                                        onClick={() => {
                                            print(props.docIds);
                                        }}
                                    >
                                        <i className='fas fa-print' />
                                        Print
                                    </span>
                                </Dropdown.Item>
                                <Dropdown.Item title='Download'>
                                    <span
                                        onClick={() => {
                                            downloadMultipleDoc(props.docIds);
                                        }}
                                    >
                                        <i className='fas fa-download' />
                                        Download
                                    </span>
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <OverlayTrigger
                            placement='top'
                            onEntering={entering}
                            overlay={
                                <Tooltip
                                    id='tooltip'
                                    style={{
                                        backgroundColor: 'rgb(0, 35, 58)',
                                        color: 'white',
                                        marginBottom: '20px',
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: 'rgb(0, 35, 58)',
                                            color: 'white',
                                        }}
                                    >
                                        Close
                                    </div>
                                </Tooltip>
                            }
                        >
                            <div className='icon_fun outer-col no-bg'>
                                <i
                                    className='fa-light fa-xmark'
                                    onClick={() => {
                                        props.closefn();
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>
            <Notes
                openNote={openNote}
                docId={props.docIds}
                handleReset={handleReset}
            />
            {restrictAllowEdit ? (
                <AllowMultipleEditModal
                    restrictAllowEdit={restrictAllowEdit}
                    handleCloseOperation={handleCloseOperation}
                    editURL={editURL}
                    handleMultiplePage={handleMultiplePage}
                    selectedDocID={
                        location.state !== undefined &&
                        location.state !== null &&
                        location.state.selectedDocID !== undefined &&
                        location.state.selectedDocID !== null
                            ? location.state.selectedDocID
                            : undefined
                    }
                    processId={
                        location.state !== undefined &&
                        location.state !== null &&
                        location.state.processId !== undefined &&
                        location.state.processId !== null
                            ? location.state.processId
                            : undefined
                    }
                    statusId={
                        location.state !== undefined &&
                        location.state !== null &&
                        location.state.statusId !== undefined &&
                        location.state.statusId !== null
                            ? location.state.statusId
                            : undefined
                    }
                />
            ) : null}
        </>
    );
}
